import SplitPianoRollPattern from './SplitPianoRollPattern.js';

export function deletePatternsSelection(track, start, end) {
    let overlappingStart = track.patterns.find(
        pattern => pattern.overlapsStep(start) && pattern.startStep < start);
    splitPattern(overlappingStart, start);
    let overlappingEnd = track.patterns.find(
        pattern => pattern.overlapsStep(end) && pattern.startStep < end);
    splitPattern(overlappingEnd, end);
    
    let patternsToKeep = track.patterns.filter(
        pattern => {
            let _start = pattern.startStep;
            let _end  = pattern.startStep + pattern.length();
            if ((_start >= start && _start < end) ||
                (_end > start && _end <= end)) {
                return false;
            }
            return true;
        });
    
    track.patterns = patternsToKeep;
    track.updateSteps(true);
}

function splitPattern(pattern, step) {
    if (pattern === undefined) {
        return;
    }
    
    new SplitPianoRollPattern(pattern.track, pattern, step)
        .execute();
}
